import { create } from 'zustand';

import { LocalStorageItems } from '@/constants';
import { sizes } from '@/theme/variables';

interface SidebarState {
  isOpen: boolean;
  width: number;
  setIsOpen: (isOpen: boolean) => void;
  setWidth: (width: number) => void;
  toggle: () => void;
}

const initialOpen = localStorage.getItem(LocalStorageItems.ExpandedSidebar);

export const useSidebarStore = create<SidebarState>((set) => ({
  isOpen: initialOpen === null || initialOpen === 'true',
  width:
    initialOpen === null || initialOpen === 'true'
      ? sizes.sidebarOpen
      : sizes.sidebarClosed,
  setIsOpen: (isOpen) =>
    set({ isOpen, width: isOpen ? sizes.sidebarOpen : sizes.sidebarClosed }),
  setWidth: (width) => set({ width }),
  toggle: () =>
    set((state) => {
      const next = !state.isOpen;
      localStorage.setItem(LocalStorageItems.ExpandedSidebar, String(next));
      return {
        isOpen: next,
        width: next ? sizes.sidebarOpen : sizes.sidebarClosed,
      };
    }),
}));
